import { render, staticRenderFns } from "./DirIcon.vue?vue&type=template&id=f2e488a4&"
import script from "./DirIcon.vue?vue&type=script&lang=js&"
export * from "./DirIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports